/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEventHandler, useCallback} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import KeyboardArrowLeftTwoTone from '@material-ui/icons/KeyboardArrowLeftTwoTone';
import {translate} from '@ion/core/src/locale/locale';
import {IconButton} from '@ion/dls/src/components/buttons/IconButton';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {MapLocateIcon} from '@ion/dls/src/icons/MapLocateIcon';
import {MapPinIcon} from '@ion/dls/src/icons/MapPinIcon';
import {SystemFindNearestIcon} from '@ion/dls/src/icons/SystemFindNearestIcon';
import {SystemViewHistoryIcon} from '@ion/dls/src/icons/SystemViewHistoryIcon';
import Render from '@ion/dls/src/render/Render';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {isCurrentTheme} from '@ion/dls/src/theme/useThemeContext';
import {hasHistoryAccess} from '@/security/Features';
import {CtaType} from './SelectedAssetPopup';

export interface SelectedAssetPopupCTAProps {
  onClickCta: (cta: CtaType) => MouseEventHandler<HTMLButtonElement>;
  showFindNearBy: boolean;
  classes: any;
  isHistoryEnabled?: boolean;
  showTooltip?: boolean;
  setShowTooltip?: Function;
}

const useStyles = makeStyles(() => ({
  label : {
    height : '22px !important',
    width  : '22px !important'
  }
}));

const SelectedAssetPopupCTA = ({
  onClickCta,
  showFindNearBy,
  classes,
  showTooltip,
  setShowTooltip,
  isHistoryEnabled
}: SelectedAssetPopupCTAProps) => {
  const styles = useStyles();

  const onMouseHover = useCallback(() => {
    setShowTooltip?.(!showTooltip);
  }, [setShowTooltip, showTooltip]);

  return (
    <div className={classes.ctaContentContainer}>
      <div className={classes.ctaContainer}>
        <Render.If condition={hasHistoryAccess() && isHistoryEnabled}>
          <Tooltip title={translate('tracking:buttons.viewHistory')} open={showTooltip} arrow>
            <IconButton icon={<SystemViewHistoryIcon />}
              onClick={onClickCta(CtaType.HISTORY)}
              onMouseEnter={onMouseHover}
              onMouseLeave={onMouseHover}
              labelClass={styles.label}
              color={dlsColor('caBlue')}
              size={'small'} />
          </Tooltip>
        </Render.If>
        <Render.If condition={!isCurrentTheme()}>
          <Tooltip id='findNearbyTooltip' title={translate('tracking:buttons.findNearby')} arrow>
            <IconButton icon={<SystemFindNearestIcon />}
              color={dlsColor('caBlue')}
              size={'small'}
              labelClass={styles.label}
              onClick={onClickCta(CtaType.FINDNEARBY)} />
          </Tooltip>
        </Render.If>
        <Tooltip title={translate('tracking:buttons.navigateTo')} arrow>
          <IconButton icon={<MapLocateIcon />}
            color={dlsColor('caBlue')}
            size={'small'}
            labelClass={styles.label}
            onClick={onClickCta(CtaType.NAVIGATION)} />
        </Tooltip>
        <Tooltip title={translate('tracking:buttons.streetView')} arrow>
          <IconButton icon={<MapPinIcon />}
            color={dlsColor('caBlue')}
            size={'small'}
            labelClass={styles.label}
            onClick={onClickCta(CtaType.STREETVIEW)} />
        </Tooltip>
      </div>
      {showFindNearBy && (
        <IconButton icon={<KeyboardArrowLeftTwoTone />}
          color={dlsColor('caBlue')}
          padding={'4px'}
          onClick={onClickCta(CtaType.BACK)} />
      )}
    </div>);
};
export default SelectedAssetPopupCTA;
